import { Link, styled } from '@mui/material';

export const ViewErrorsLink = styled(Link)(({ theme }) => ({
  color: theme.palette.error.main,
  '&:hover': {
    color: theme.palette.error.main,
  },
}));
